import { util } from 'echarts';
import { type ThemeParser } from '../../../core/theme';
import type { PresetMode } from '../..';
import { FONT_LEVEL_LIST, fontColor } from '../../mobile/static/font';
import { preporcessYAxis, defaultYAxisOpt, parseYAxis } from '../../ainvest/component/yAxis';

const mergeYAxis = (themeMode: PresetMode) => {
  return {
    splitLine: {
      lineStyle: {
        width: 1,
        color: themeMode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.07)'
      }
    },
    axisLabel: {
      inside: false,
      verticalAlign: 'center',
      color: fontColor(FONT_LEVEL_LIST.LEVEL1, themeMode),
      fontSize: 11,
      margin: 8,
      lineHeight: 16,
      align: 'right',
      dvAlignEdge: false,
      dvAlignLabelsToAxis: true
    }
  };
};

const defaultYAxis = (themeMode: PresetMode) => {
  return util.merge(defaultYAxisOpt(themeMode), mergeYAxis(themeMode), true);
};

export function yAxisThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  preporcessYAxis(option);
  parseYAxis(option, defaultYAxis(themeMode));
}
